import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GoogleLogo } from "@phosphor-icons/react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Standard Google OAuth 2.0 callback landing page. Google redirects the browser
// here (redirect_uri = window.location.origin + "/auth/google") with ?code&state.
// We validate state (CSRF), exchange the code server-side, then continue.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const saved = sessionStorage.getItem("g_oauth_state");
    const nonce = sessionStorage.getItem("g_oauth_nonce");

    if (params.get("error")) {
      navigate("/login", { replace: true });
      return;
    }
    if (!code || !state || state !== saved || !nonce) {
      setError("Invalid or expired sign-in request.");
      setTimeout(() => navigate("/login", { replace: true }), 1800);
      return;
    }
    sessionStorage.removeItem("g_oauth_state");
    sessionStorage.removeItem("g_oauth_nonce");
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUri = window.location.origin + "/auth/google";
    api.post("/auth/google/callback", { code, redirect_uri: redirectUri, nonce })
      .then(async () => { await checkAuth(); navigate("/dashboard", { replace: true }); })
      .catch((e) => {
        setError(apiError(e));
        setTimeout(() => navigate("/login", { replace: true }), 2500);
      });
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background" data-testid="google-callback">
      <GoogleLogo size={40} weight="bold" className="text-foreground animate-pulse" />
      {error ? (
        <p className="text-sm text-destructive" data-testid="google-callback-error">{error}</p>
      ) : (
        <p className="text-sm text-muted-foreground">Signing you in with Google…</p>
      )}
    </div>
  );
}
